import { generatePlugin } from '../component';

//pcoPlugin
export const pcoPlugin = generatePlugin('pco');
//ocoPlugin
export const ocoPlugin = generatePlugin('oco');
//scoPlugin
export const scoPlugin = generatePlugin('sco');
//rcoPlugin
export const rcoPlugin = generatePlugin('rco');
//rfqPlugin
export const rfqPlugin = generatePlugin('rfq');
